(() => {
  const image = document.getElementById('op-product-main');
  const thumbs = Array.from(document.querySelectorAll('[data-product-image]'));
  const arrows = Array.from(document.querySelectorAll('[data-gallery-step]'));
  let active = 0;
  const imageKey = src => { try { return new URL(src, location.href).pathname; } catch { return src; } };
  const sync = () => {
    thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === active)));
    arrows.forEach(arrow => {
      const target = (active + Number(arrow.dataset.galleryStep) + thumbs.length) % thumbs.length;
      arrow.setAttribute('aria-label', thumbs[target]?.getAttribute('aria-label') || '');
    });
    const strip = thumbs[active]?.parentElement;
    if (strip) strip.scrollTo({ left: Math.max(0, thumbs[active].offsetLeft - strip.offsetLeft - (strip.clientWidth - thumbs[active].offsetWidth) / 2), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  const setImage = src => {
    if (!image || !src) return;
    image.src = src;
    image.removeAttribute('srcset');
    const index = thumbs.findIndex(thumb => imageKey(thumb.dataset.productImage) === imageKey(src));
    if (index >= 0) active = index;
    sync();
  };
  thumbs.forEach(thumb => thumb.addEventListener('click', () => setImage(thumb.dataset.productImage)));
  arrows.forEach(arrow => arrow.addEventListener('click', () => {
    if (!thumbs.length) return;
    active = (active + Number(arrow.dataset.galleryStep) + thumbs.length) % thumbs.length;
    setImage(thumbs[active].dataset.productImage);
  }));
  if (image && thumbs.length) {
    const initial = thumbs.findIndex(thumb => imageKey(thumb.dataset.productImage) === imageKey(image.src));
    if (initial >= 0) active = initial;
    sync();
  }
  const select = document.getElementById('op-variant'), data = document.getElementById('op-variant-data');
  if (!select || !data) return;
  const variants = JSON.parse(data.textContent), button = document.getElementById('op-add-to-cart');
  const apply = () => {
    const variant = variants.find(item => String(item.id) === select.value);
    if (!variant) return;
    const currency = document.createElement('span');
    currency.className = 'op-currency';
    currency.textContent = '€';
    const priceNodes = [document.createTextNode(variant.price + '\u00a0'), currency];
    if (variant.comparePrice) {
      const previous = document.createElement('s');
      previous.className = 'op-detail-previous-price';
      previous.append(document.createTextNode(variant.comparePrice + '\u00a0'), currency.cloneNode(true));
      priceNodes.unshift(previous);
    }
    document.getElementById('op-detail-price').replaceChildren(...priceNodes);
    button.disabled = !variant.available;
    button.textContent = variant.available ? button.dataset.available : button.dataset.unavailable;
    setImage(variant.image);
    const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
  };
  const swatches = Array.from(document.querySelectorAll('[data-colour-variant]'));
  const colourName = document.getElementById('op-colour-name');
  const syncColours = () => {
    swatches.forEach(swatch => {
      const selected = swatch.dataset.colourVariant === select.value;
      swatch.setAttribute('aria-pressed', String(selected));
      if (selected && colourName) colourName.textContent = swatch.dataset.colourName;
    });
  };
  swatches.forEach(swatch => swatch.addEventListener('click', () => {
    select.value = swatch.dataset.colourVariant;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  select.addEventListener('change', () => { apply(); syncColours(); });
  syncColours();
})();